import styled from "styled-components"
import { Size, sizeToCss } from "./sizes"

export const Ul = styled.ul<{ size?: Size }>`
  ${(props) => {
    if (props.size) {
      return sizeToCss(props.size)
    }
    return sizeToCss("L")
  }}
`
